
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, watch, reactive, toRefs } from 'vue'
import {formatSeconds} from '@/utils/timeFormat'
import { init, EChartsOption } from 'echarts'
import i18n from "@/locales/index";
const _t = i18n.global.t;
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'echartsWorkingTimeComponents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '280px',
      required: true
    },
    dataY: {
      type: Array,
      default: '',
    },
    dataX: {
      type: Array,
      default: '',
    },
    max: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const state = reactive({
      y_interval: (props.max + 3600) / 3
    })
    const initChart = () => {
      state.y_interval = (props.max + 3600) / 3
      let lineCharts: any
      const getTimeChange = (time: any) => {
        if (isNaN(time)) return null
        const str = formatSeconds(time)
        return str
      }
      lineCharts = init(document.getElementById(props.id) as HTMLDivElement)
      lineCharts.setOption({
        title: {
          subtext: `${_t('home.workinghours')}（${_t('home.hour')}）`,
          subtextStyle: {
            fontSize: 12,
          },
          textStyle: {
            fontWeight: 'bold',
            fontSize: 15
          },
          itemGap: 20,
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params: any) => {
            let index = params[0].dataIndex
            let dataY_ARR_0 = props.dataY[0] as any
            let dataY_ARR_1 = props.dataY[1] as any
            return `${props.dataX[index]}` + '<br/>' + `${_t('home.numberofworkmachs')}：${dataY_ARR_1[index]}` + _t('account.platform') + '<br/>' + `${_t('home.workinghours')}：${getTimeChange(dataY_ARR_0[index])}`
          },
          // valueFormatter: (value?: any) => getTimeChange(value),
        },
        xAxis: {
          type: 'category',
          data: props.dataX
        },
        yAxis: {
          type: 'value',
          max: props.max + 3600,
          min: 0,
          interval: state.y_interval,//设置刻度间距
          // max: 6,
          // splitNumber: 3 // 横线数
          axisLabel: {
            formatter: (value: any) => {
              let num = value / 60 / 60
              return num.toFixed(1)
            }
          },
        },
        color: ['#45A0FF'],
        series: [
          {
            data: props.dataY[0],
            type: 'line'
          }
        ],
        
      } as EChartsOption)
    }

    watch(() => props, (newVal, oldVal) => {
      setTimeout(() => {
        initChart()
      }, 500)
    }, { deep: true })

    onMounted(() => {
      setTimeout(() => {
        initChart()
      }, 500)
    })

    onBeforeUnmount(() => {

    })

    onActivated(() => {

    })

    onDeactivated(() => {

    })

    return {
      ...toRefs(state)
    }
  }
})
